import React, { ReactNode } from 'react'

import {
  Grid,
} from '@material-ui/core'

interface DetailTabProps {
  children?: ReactNode
}

export const DetailTab = (props: DetailTabProps) => {
  const { children = [] } = props

  return (
    <Grid container spacing={6}>
      {Array.isArray(children) ? (
        <>
          {children.map((child: ReactNode, index: number) => (
            <Grid item xs={12} key={index}>
              {child}
            </Grid>
          ))}
        </>
      ) : (
        <Grid item xs={12}>
          {children}
        </Grid>
      )}
    </Grid>
  )
}
